import { Card, Col, Input, Row, RowProps } from 'antd';
import styled, { css } from 'styled-components';

export const MainContainer = styled(props => <Row wrap={false} {...props} />)<
  RowProps
>`
  margin: 12px;
`;

export const LeftCol = styled(Col)<{ $width?: number }>(
  ({ $width = 294 }) => css`
    min-width: ${$width}px;
    width: ${$width}px;
  `,
);

export const ItemsList = {
  Card: styled(Card)<{ $maxHeight?: string }>`
    overflow: hidden;
    max-height: ${({ $maxHeight = 'calc(100vh - 163px)' }) => $maxHeight};
    overflow: auto;
    .ant-card-body {
      padding: 24px 0;
    }
  `,
  SearchInput: styled(Input)`
    margin: 0px 24px 10px;
    width: calc(100% - 48px);
  `,
};

export const StyledResourceCompaniesCard = styled(Card)<{
  $headerWithTabs?: boolean;
}>`
  margin-left: 12px;
  width: calc(100% - 12px);
  height: calc(100vh - 175px);
  overflow: hidden;
  .ant-card-body {
    max-height: ${p =>
      p.$headerWithTabs ? 'calc(100% - 122px)' : 'calc(100% - 65px)'};
    overflow: auto;
  }
`;
